import { UNLIMITED_TIER } from "@chesshotel/constants";
import useTranslation from "next-translate/useTranslation";
import { FaInfinity } from "react-icons/fa";
import { useMembership } from "../../redux/membership";
import { useUser } from "../../redux/user";

export default function MembershipInfo() {
  const { t } = useTranslation("common");
  // const { t: lobbyT } = useTranslation("lobby");
  const { leagueGames, tier, gameReviews } = useMembership();
  const { memberLoggedIn } = useUser();

  if (!memberLoggedIn) {
    return null;
  }

  return (
    <div
      className="hidden md:flex self-start bg-gray-200 border rounded-b-md 
      px-3 py-1.5 text-xs whitespace-nowrap"
    >
      <div className="mr-1 uppercase">{t("League games")}</div>
      <div className="font-bold">
        {tier === UNLIMITED_TIER ? <FaInfinity /> : leagueGames}
      </div>
      <div className="mr-1 ml-2 uppercase">{t("Game Reviews")}</div>
      <div className="font-bold uppercase">
        {tier === UNLIMITED_TIER ? <FaInfinity /> : gameReviews}
      </div>
    </div>
  );
}
